import * as React from 'react';
const FavoriteIcon = ({ width = 16, height = 15, ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 16 15'
    fill='none'
    {...props}
  >
    <path
      d='m7.969 2.813.375-.344a4.45 4.45 0 0 1 3.906-1.25A4.465 4.465 0 0 1 16 5.625v.156a4.73 4.73 0 0 1-1.5 3.438L8.844 14.5c-.219.219-.531.313-.844.313-.344 0-.656-.094-.875-.313L1.469 9.219A4.7 4.7 0 0 1 0 5.78v-.156c0-2.187 1.563-4.062 3.719-4.406a4.45 4.45 0 0 1 3.906 1.25zm0 1.437L6.906 3.156a3.48 3.48 0 0 0-3.031-.969A3.49 3.49 0 0 0 .969 5.626v.156c0 1.032.437 2 1.187 2.688l5.656 5.281c.032.063.094.063.157.063.093 0 .156 0 .187-.063l5.656-5.281A3.64 3.64 0 0 0 15 5.78v-.156a3.49 3.49 0 0 0-2.906-3.437 3.48 3.48 0 0 0-3.031.968z'
      fill='currentColor'
    />
  </svg>
);
export default FavoriteIcon;
